import { render } from "./RecordBookItems.vue?vue&type=template&id=8222c1c8&lang=pug"
import script from "./RecordBookItems.vue?vue&type=script&lang=js"
export * from "./RecordBookItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__